import React, { useState } from 'react';
import WarningOutlinedIcon from '@material-ui/icons/WarningOutlined';

import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import styled from 'styled-components'
import ChartistGraph from 'react-chartist';
 
const LI = styled.li`
 


  
  `
const RLI = styled.li`
@media screen and (max-width: 48rem){
  margin-left: 60%;
  margin-top: 2.5rem;
}
@media screen and (min-width: 48rem){
  margin-left: 75%;
  margin-top: 2.5rem;
}
`
  const REPORT = styled.button`
  padding: .5rem;
  background: white;
  border: 2px solid purple;
  font-weight: normal;
  font-size: large;
  transition: ease-in-out 1s;
  outline: none;
  
  &:hover {
    box-shadow: .0rem .1rem  .1rem silver;
    background: purple;
    color: white;
    transition: ease-in-out .5s;
    border:none;
    outline: none;
    transform: translateY(-.3rem);
    cursor:pointer;
    border-radius: .5rem;
    padding: .7rem;
  }
  
  `
  const RESHEET = styled.p`
     border: 2px dashed #a4508b;
     padding: .5rem;
     overflow: auto;
     width: fit-content;
     word-break: break;
     height: fit-content;
     margin: 2rem auto .5rem 0rem;
     line-height: 2rem;
     font-weight: normal;

`
// let simpleLineChartData = {
//     labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
//     series: [
//       [12, 9, 7, 8, 5],
//       [2, 1, 3.5, 7, 3],
//       [1, 3, 4, 5, 6]
//     ]
//   }
const FinReport = (props) => {
  const giveMeLabel = (spend, gain, label = []) => {
     let emptyLabel = []
  if(spend > gain) {
    for (let i = 0; i < spend; i++) {
       emptyLabel.push(label[i])
    }
  }
  else {
        for (let i = 0; i < gain; i++) {
           emptyLabel.push(label[i])
        }

  }
  return emptyLabel.map(s => s.substring(0,3))
  }
  const [view, setView] = useState(true)
    return ( 
        <>
<article style={{background:'silver', padding:'0', margin:'0', width:'100%'}} >
            <ul style={{listStyleType:'none', background: 'white', width: 'auto', padding:'1rem', paddingInlineStart:'.5px', marginBlockEnd:'0', marginLeft:'.5' }}>
                <li><WarningOutlinedIcon style={{color:'red', marginLeft: '2rem', verticalAlign: 'sub'}}  />
                <span style={{color:'silver', marginRight:'1rem'}}> (Spent / withdrawn)</span>
                <span style={{fontWeight:'bold'}}>

                N {props.monSpendTot}
                </span>
                </li>
                <li style={{marginTop:'2rem'}}><CheckCircleOutlineOutlinedIcon style={{color:'limegreen', marginLeft: '2rem', verticalAlign: 'sub'}}  />
                <span style={{color:'silver', marginRight:'1rem'}}> (Recived / gain)</span>
                <span style={{fontWeight:'bold'}}>

                N {props.monGainTot}
                </span>
                </li>
                
                <LI style={{marginTop:'2rem', marginLeft:'2.5rem'}}>
                <span style={{fontWeight:'normal'}}>
                Balance:
                </span>
                <span style={{marginLeft:'1rem',fontWeight:'bold'}}>{props.balc} </span></LI>

              <RLI>
              <REPORT style={{display:'inline-block'}} onClick={() =>{view ? setView(false): setView(true)}}>{view ? 'Show report' : 'Hide report'} </REPORT> 
            
              </RLI>

              <RESHEET style={view ? {display:'none'}: {display:'block'}}> {props.reportSheet(props.monSpendTot, props.monGainTot)} </RESHEET>
                
                
            </ul>
        
        

<ChartistGraph 
data={{
    labels: giveMeLabel(props.spendArr.length, props.gainArr.length, props.label),
    series: [props.spendArr,
      props.gainArr,
  
    ]
  }} 
  options={
    {
      donut: true,
      showlabel: false
    }
  }
  type={'Pie'}
 
  />
        </article>

        </>
     );
}
FinReport.defaultProps = {
    spendArr: [12, 9, 7, 8, 5],
    gainArr: [2, 1, 3.5, 7, 3],
    label: ['Mon', 'Tue', 'Wed', 'Thur', 'Fri']
}

// const mapStateToProps = ({Fs}) => {
//   return {
//     label: Fs.map(s => s.budg)
//   }
// }
 
export default  FinReport;